export function maybeAddContainer(id: string) {
    if (!document.getElementById(id)) {
        addContainer(id);
    }
}

function addContainer(id: string) {
    document.body.appendChild(makeElement('div', id));
}

function makeElement(tagName: string, id: string): HTMLElement {
    const element = document.createElement(tagName);
    element.setAttribute('id', id);
    return element;
}
